import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call } from 'redux-saga/effects';
import { msas } from 'redux/saga/entities/bound';
import { get as getMsaAliasToId } from 'dynamic-data/msa-alias-to-id';
import { msaByAlias } from 'redux/saga/selectors/msas';

export function* getMsaFromPath(client, path) {
  const msaAliases = getMsaAliasToId();
  const msasList = yield call(fetchEntityIfNeeded, msas, [client]);

  const parts = (path || '').split('/');
  const msaAlias = parts.find(part => part in msaAliases);

  return msaByAlias(msasList, msaAlias);
}
